// extracted by mini-css-extract-plugin
module.exports = {"dp-file-upload--explain":"dp-file-upload--explain___27F-1","api-uploader-container":"api-uploader-container___a7xwh"};